module.exports = __webpack_public_path__ + "assets/amex.6ca7e897.svg";